import React, { useMemo } from 'react';
import Keyboard from 'react-simple-keyboard';
import 'simple-keyboard/build/css/index.css';
import './alphaModern.css';
import { useKeyboard } from '../../../context/KeyboardContext';

const keyboardFallbackCss = `
.simple-keyboard {
  width: 100% !important;
  max-width: 100% !important;
}
.simple-keyboard .hg-rows {
  width: 100% !important;
}
.simple-keyboard .hg-row {
  display: flex !important;
  width: 100% !important;
  gap: 8px !important;
  margin-bottom: 8px !important;
}
.simple-keyboard .hg-button {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex: 1 1 0 !important;
  min-height: 56px !important;
  border: 1px solid #d1d5db !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  color: #111827 !important;
  font-size: 24px !important;
  line-height: 1 !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08) !important;
}
`;

const AlphaKeyboard = () => {
  const kb = useKeyboard();

  const layout = useMemo(() => {
    const showEnter = kb?.options?.showEnter !== false; // default true
    const includeComma = kb?.options?.includeComma === true;
    if (kb.type === 'email') {
      return {
        default: [
          '1 2 3 4 5 6 7 8 9 0',
          'q w e r t y u i o p',
          'a s d f g h j k l',
          '{shift} z x c v b n m {backspace} {clear}',
          showEnter ? '@ . _ - {dotcom} {space} {enter}' : '@ . _ - {dotcom} {space}'
        ],
        shift: [
          '! @ # $ % ^ & * ( )',
          'Q W E R T Y U I O P',
          'A S D F G H J K L',
          '{shift} Z X C V B N M {backspace} {clear}',
          showEnter ? '@ . _ - {dotcom} {space} {enter}' : '@ . _ - {dotcom} {space}'
        ]
      };
    }
    const bottomRow = includeComma
      ? (showEnter ? ', {space} {enter}' : ', {space}')
      : (showEnter ? '{space} {enter}' : '{space}');
    return {
      default: [
        '1 2 3 4 5 6 7 8 9 0',
        'q w e r t y u i o p',
        'a s d f g h j k l',
        '{shift} z x c v b n m {backspace} {clear}',
        bottomRow
      ],
      shift: [
        '! @ # $ % ^ & * ( )',
        'Q W E R T Y U I O P',
        'A S D F G H J K L',
        '{shift} Z X C V B N M {backspace} {clear}',
        bottomRow
      ]
    };
  }, [kb.type, kb?.options?.showEnter]);

  const display = {
    '{bksp}': '⌫',
    '{backspace}': '⌫',
    '{shift}': '⇧',
    '{space}': 'Space',
    '{enter}': 'Enter',
    '{clear}': 'Clear',
    '{dotcom}': '.com'
  };

  const onKeyPress = (button) => {
    if (!kb) return;
    if (button === '{backspace}' || button === '{bksp}') return kb.onBackspace && kb.onBackspace();
    if (button === '{enter}') return kb.onEnter && kb.onEnter();
    if (button === '{clear}') return kb.onClear && kb.onClear();
    if (button === '{dotcom}') return kb.onInput && kb.onInput('.com');
    if (button === '{shift}') return; // handled internally by library
    if (button === '{space}') return kb.onInput && kb.onInput(' ');
    // normal char
    kb.onInput && kb.onInput(button);
  };

  return (
    <div style={{ padding: 4, touchAction: 'manipulation', WebkitTapHighlightColor: 'transparent', userSelect: 'none' }}>
      <style>{keyboardFallbackCss}</style>
      <Keyboard
        layout={layout}
        display={display}
        theme={"hg-theme-default kb-modern"}
        onKeyPress={onKeyPress}
      />
      <div style={{ display:'flex', justifyContent:'center', padding: 4 }}>
        <button
          type="button"
          style={{
            padding: '10px 18px',
            fontSize: 16,
            fontWeight: 600,
            border: '1px solid #d1c4e9',
            color: '#4a148c',
            background: '#f3e5f5',
            borderRadius: 9999,
            boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
            touchAction: 'manipulation',
            WebkitTapHighlightColor: 'transparent',
            userSelect: 'none',
            cursor: 'pointer'
          }}
          onPointerDown={(e) => { if (e && e.preventDefault) e.preventDefault(); kb.close(); }}
        >
          ✕ Close
        </button>
      </div>
    </div>
  );
}
;

export default AlphaKeyboard;
